const primeraVezSubsecuentaOpt = [
  { value: "0", label: "Primera vez" },
  { value: "1", label: "Subsecuente" },
];

const noAplicaOpt = [{ value: "-1", label: "No aplica" }];

const noSiOpt = [
  { value: "0", label: "No" },
  { value: "1", label: "Si" },
];

const attPregestacionalOpt = [
  { value: "1", label: "Patología crónica órgano funcional" },
  { value: "2", label: "Patología crónica infecciosa" },
  { value: "3", label: "Morbilidad materna externa" },
  { value: "4", label: "Con factores de riesgo sociales" },
  { value: "5", label: "Antecedentes obstétricos de riesgo" },
];
const attPreSinAnt = [{ value: "9", label: "Sin antecedentes" }];

const opt123 = [
  { value: "1", label: "Primero" },
  { value: "2", label: "Segundo" },
  { value: "3", label: "Tercero" },
];
const pesoTallaOpt = [
  { value: "1", label: "Obesidad" },
  { value: "2", label: "Sobrepeso" },
  { value: "3", label: "Normal" },
  { value: "4", label: "Desnutrición Leve" },
  { value: "5", label: "Desnutrición Moderada" },
  { value: "6", label: "Desnutrición Grave" },
];

const inicialSubsecuentaOpt = [
  { value: "1", label: "Inicial" },
  { value: "2", label: "Subsecuente" },
];
const resultadoEdiOpt = [
  { value: "1", label: "Verde" },
  { value: "2", label: "Amarillo" },
  { value: "3", label: "Rojo" },
  { value: "4", label: "Recuperado de Rezago" },
  { value: "5", label: "Recuperado de Riesgo de retraso" },
  { value: "6", label: "En seguimiento" },
];
const resultadoBatelleOpt = [
  { value: "1", label: "Mayor o igual a 90" },
  { value: "2", label: "de 89 a 80" },
  { value: "3", label: "Menor o igual a 79" },
];
const aplicacionCedulaCanOpt = [
  { value: "1", label: "Primera vez en el año" },
  { value: "2", label: "Segunda vez en el año" },
];
const edasPlanTratamientOpt = [
  { value: "1", label: "Plan A" },
  { value: "2", label: "Plan B" },
  { value: "3", label: "Plan C" },
];
const irasPlanTratamientoOpt = [
  { value: "1", label: "Sintomático" },
  { value: "2", label: "Antibiótico" },
];
const sintomaDepresivaOpt = [
  { value: "1", label: "Preventiva" },
  { value: "2", label: "Tratamiento" },
];
const referidoPorOpt = [
  { value: "1", label: "Embarazo Alto Riesgo" },
  { value: "2", label: "Sospecha Cáncer < 18 AñoS" },
  { value: "3", label: "Por Iras" },
  { value: "4", label: "Por Neumonía" },
  { value: "5", label: "Otras" },
  { value: "6", label: "Cisticercosis" },
  { value: "7", label: "Emergencia Obstétrica –Preeclampsia" },
  { value: "8", label: "Emergencia Obstétrica –Hemorragia" },
  { value: "9", label: "Otra Emergencia Obstétrica" },
];

export {
  noAplicaOpt,
  primeraVezSubsecuentaOpt,
  noSiOpt,
  attPregestacionalOpt,
  attPreSinAnt,
  opt123,
  pesoTallaOpt,
  inicialSubsecuentaOpt,
  resultadoEdiOpt,
  resultadoBatelleOpt,
  aplicacionCedulaCanOpt,
  edasPlanTratamientOpt,
  irasPlanTratamientoOpt,
  sintomaDepresivaOpt,
  referidoPorOpt
};
